import React, { useEffect, useEffectEvent, useState } from 'react'
import { useParams } from 'react-router'

import useApplicantTokenOnMount from '@sputnik/hooks/useApplicantTokenOnMount'

import AcceptingOfferPollingPageContent from './AcceptingOfferPollingPageContent'
import { useGetApplicationStatusForPolling } from './GetApplicationStatusForPolling.gql'

const POLLING_MAX_TIMEOUT = 60000
const POLLING_RATE = 5000

const AcceptingOfferPollingPage = () => {
  /* make sure we have a token before we start polling */
  const { appId } = useParams()
  useApplicantTokenOnMount({ salesforceCreditId: appId || '' })

  const [isReadyToNavigate, setIsReadyToNavigate] = useState(false)
  const onReadyToNavigate = useEffectEvent(() => setIsReadyToNavigate(true))
  const [timer, setTimer] = useState(0)

  const { data, loading, startPolling, stopPolling } = useGetApplicationStatusForPolling({
    fetchPolicy: 'network-only',
    skip: !appId,
    variables: { creditApplicationId: appId as string },
  })

  const { authorizedSigner, applicationActionItems, companyDivvyUuid } = data?.creditApplication || {}

  const hasPollingTimedOut = timer >= POLLING_MAX_TIMEOUT
  const invitationToken = authorizedSigner?.accountSetupInvitation?.token ?? undefined
  const shouldNavigateImmediatelyStatus =
    (applicationActionItems?.some(({ action, completedAt }) => action === 'review_offer' && completedAt !== null) ||
      !!invitationToken) &&
    timer >= POLLING_RATE

  const finishedPolling = (hasPollingTimedOut || shouldNavigateImmediatelyStatus) && !loading && !!data

  // handle polling
  useEffect(() => {
    startPolling(POLLING_RATE)
    if (hasPollingTimedOut) {
      onReadyToNavigate()
    } else {
      setTimeout(() => setTimer(timer + POLLING_RATE), POLLING_RATE)
    }
  }, [hasPollingTimedOut, startPolling, stopPolling, timer])

  return (
    <AcceptingOfferPollingPageContent
      key={isReadyToNavigate.toString()}
      companyDivvyUuid={companyDivvyUuid ?? ''}
      invitationToken={invitationToken}
      isReadyToNavigate={finishedPolling || isReadyToNavigate}
      stopPolling={stopPolling}
    />
  )
}

export default AcceptingOfferPollingPage
